import index from '@/data/blog_index.json';
import topics from '@/data/blog_topics.json';

// Data blog statik (dijana oleh scripts/gen_blog_data.js). Dipakai sebagai render pertama supaya H1/kandungan
// SEO muncul tanpa tunggu API; respons API (views, tarikh, suntingan admin) menggantikannya bila tiba.
const clusterOf = slug => topics.clusters.find(c => c.slug === slug) || null;

export function staticPost(slug) {
  const p = index.find(x => x.slug === slug);
  if (!p) return null;
  const c = clusterOf(p.cluster);
  return { ...p, topic: c ? { slug: c.slug, name: c.name } : null, related_service_url: p.service, related_service_label: p.service_label };
}

export const loadStaticContent = slug =>
  import(/* webpackChunkName: "blog-[request]" */ `../data/blog_content/${slug}.json`).then(m => m.default.content);

export const staticRelated = post => index.filter(p => p.slug !== post.slug && p.cluster === post.cluster).slice(0, 4);

export const staticPosts = () => index;

export function staticTopicList() {
  return topics.clusters
    .map(c => ({ slug: c.slug, name: c.name, short: c.short, count: index.filter(p => p.cluster === c.slug).length }))
    .filter(t => t.count);
}

export function staticTopic(cluster) {
  const c = clusterOf(cluster);
  const posts = index.filter(p => p.cluster === cluster);
  if (!c || !posts.length) return null;
  const order = topics.intent_order;
  posts.sort((a, b) => order.indexOf(a.intent) - order.indexOf(b.intent) || a.title.localeCompare(b.title));
  const stages = order
    .map(i => ({ intent: i, label: topics.intent_labels[i], posts: posts.filter(p => p.intent === i) }))
    .filter(s => s.posts.length);
  return { topic: c, stages, total: posts.length, others: topics.clusters.filter(o => o.slug !== cluster).map(o => ({ slug: o.slug, name: o.name })) };
}
